import { useEffect, useState } from 'react';

export const useSendMessageError = () => {
  const handler = useState(false);
  const [hasError, setHasError] = handler;
  useEffect(
    () => {
      let timeout: NodeJS.Timeout | undefined;
      if (hasError) {
        timeout = setTimeout(() => setHasError(false), 10_000);
      }
      return () => {
        if (timeout) {
          clearTimeout(timeout);
        }
      };
    },
    [
      hasError,
      setHasError,
    ],
  );
  return handler;
};
